<template>
  <group :title="title" class="car_info_item">
    <cell>
      <flexbox slot="after-title" class="info_flex" v-for="(item, index) in titleList" :key="index">
        <flexbox-item class="name" :span="190/690">{{item.name}}</flexbox-item>
        <flexbox-item class="value">{{dataList[item.key]}}</flexbox-item>
      </flexbox>
    </cell>
  </group>
</template>
<script>
import {
  Group,
  Cell,
  Flexbox,
  FlexboxItem
} from '@lx-frontend/cvux'
export default {
  components: {
    Group,
    Cell,
    Flexbox,
    FlexboxItem
  },
  props: {
    title: {
      type: [String, Number],
      default: '标题'
    },
    titleList: {
      type: Array,
      default() {
        return []
      },
      required: true
    },
    dataList: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}

</script>
<style lang="less">
@import '../../stylesheets/base/fn';
.car_info_item {
  .weui_cells_title {
    opacity: 1;
    font-size: 30/@w2;
  }
  .weui_cells:before {
    left: 30/@w2;
  }
  .weui_cells:after {
    display: none;
  }
  .info_flex {
    align-items: flex-start;
    padding-bottom: 20/@w2;
    font-size: 26/@w2;
    .name {
      line-height: 1.4;
      color: #9a9a9a;
    }
    .value {
      line-height: 1.4;
    }
  }
}

</style>
